<template>
  <div class="relatorios-page">
    <div class="page-header">
      <h1 class="page-title">{{ t('relatoriosPage.title') }}</h1>
      <p class="page-subtitle">{{ t('relatoriosPage.subtitle') }}</p>
    </div>
    
    <div class="page-content">
      <div class="coming-soon-card">
        <div class="coming-soon-icon">
          <svg class="w-16 h-16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
          </svg>
        </div>
        <h2 class="coming-soon-title">{{ t('relatoriosPage.comingSoonTitle') }}</h2>
        <p class="coming-soon-description">
          {{ t('relatoriosPage.comingSoonDescription') }}
        </p>
        <div class="coming-soon-features">
          <div class="feature-item">
            <span class="feature-icon">📈</span>
            <span>{{ t('relatoriosPage.features.chartsMetrics') }}</span>
          </div>
          <div class="feature-item">
            <span class="feature-icon">📊</span>
            <span>{{ t('relatoriosPage.features.productivityAnalysis') }}</span>
          </div>
          <div class="feature-item">
            <span class="feature-icon">💾</span>
            <span>{{ t('relatoriosPage.features.dataExport') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<style scoped>
.relatorios-page {
  padding: 32px;
  min-height: calc(100vh - 64px);
}

.page-header {
  margin-bottom: 32px;
}

.page-title {
  font-size: 32px;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.page-subtitle {
  font-size: 16px;
  color: var(--text-secondary);
  margin: 0;
}

.page-content {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

.coming-soon-card {
  background-color: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 16px;
  padding: 48px;
  text-align: center;
  max-width: 600px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);
}

.coming-soon-icon {
  color: var(--info);
  margin-bottom: 24px;
}

.coming-soon-title {
  font-size: 24px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 16px;
}

.coming-soon-description {
  font-size: 16px;
  color: var(--text-secondary);
  line-height: 1.6;
  margin-bottom: 32px;
}

.coming-soon-features {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  color: var(--text-secondary);
}

.feature-icon {
  font-size: 18px;
}
</style>
